export const APP_ROLES = {
    editor: 'user',
    admin: 'admin',
    superAdmin: 'super_admin',
};
